import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=5db35bb6&scoped=true"
import script from "./goods-list.vue?vue&type=script&lang=js"
export * from "./goods-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db35bb6",
  null
  
)

export default component.exports